import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import TravelCard from '../../components/TravelCard';
import './index.css';

const IndiaUntamedPage = () => {
  return (
    <>
      <Navbar />
      <div className="container-color" style={{ paddingTop: '80px' }}>
        <TravelCard />
        <Contact />
      </div>
    </>
  );
};

export default IndiaUntamedPage;
